import { createApiSlice } from "@common";
import {
   MY_INFO_DEPENDENT
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeDependentDetails",
        method: "post",
        url:MY_INFO_DEPENDENT,
        stateKey: "message",
    },
    {
        name: "getEmployeeDependentDetails",
        method: "get",
        url:MY_INFO_DEPENDENT,
        stateKey: "data",
    },
    {
        name: "updateEmployeeDependentDetails",
        method: "put",
        url:MY_INFO_DEPENDENT,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeDependentDetails",
        method: "delete",
        url:MY_INFO_DEPENDENT,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeDependentDetails",
    apiConfig,
    customReducers,
);
const EmployeeDependentDetailsSlice = slice;
// Export the slice's reducer
export default EmployeeDependentDetailsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeDependentDetails,
    getEmployeeDependentDetails,
    updateEmployeeDependentDetails,
    deleteEmployeeDependentDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
